<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    itemsRight: {
      type: Array,
      required: true
    },
    depth: {
      type: Number,
      default: 0
    },
    maxDepth: {
      type: Number,
      default: 3
    },
    theme: {
      type: String,
      default: 'dark'
    },
    backText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      subMenuIndex: null
    };
  },
  methods: {
    getTarget: Fandom.getTarget,
    isItemActive(item) {
      // When url is a ContentLink extra field type the content name can be used as matching 
      // name when mathing name is missing. 
      if (item.url && item.url.content && !item.matching_name) {
        item.matching_name = item.url.content;
      }
      const re = new RegExp(`^(${item.matching_name})$`);
      return re.test(globalState.pageModel.main_content_name);
    },
    linkClickHandler(item, path) {
      if (this.subMenuIndex) {
        path.unshift(this.subMenuIndex);
      }
      this.$emit('link-click', {item, path});
    }
  },
  computed: {
  },
};
</script>

<template>
  <div mobile-menu-component class="d-xl-none overflow-hidden">
    <div class="heading px-4 d-flex align-items-center" :class="theme">
      <div v-if="backText && depth > 1" class="cursor-pointer text-uppercase font-weight-bold small" @click="$emit('close')">
        <span>{{backText}}</span><i class="fal fa-long-arrow-left ml-2"/>
      </div>
      <div v-else class="text-uppercase small font-weight-bold">
        <span>Home</span>
      </div>
    </div>
    <div class="main-box h-100" :class="theme" v-if="items.length > 0">
      <div v-for="(item, index) in items.filter(el => !el.hidden)" :key="`item-${index}`">
        <div class="px-3 py-4 bg-white" v-if="item.label">
          <span class="px-1 text-uppercase d-inline-block">{{item.label}}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between" :class="{ 'active': isItemActive(item) }" :id="`item-${index}`"> 
          <a
            :href="(item.url || {}).url || 'javascript:void(0)'"
            @click="linkClickHandler(item, [index])"
            :target="getTarget(item.url)"
            class="h5 mb-0 px-4"
            :class="items.some(el => el.items) && maxDepth > depth ? 'text-uppercase py-4' : 'font-weight-normal pt-3'"
          >
            {{(item.url || {}).title || item.title}}
          </a>
          <div v-if="!!item.items && maxDepth > depth" @click="subMenuIndex = index" class="d-flex align-items-center px-3 arrow-box align-self-stretch">
            <i class="far fa-chevron-right fa-lg px-3"></i>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in itemsRight" :key="`item-right-${index}`">
        <div class="px-3 py-4 bg-white" v-if="item.label">
          <span class="px-1 text-uppercase d-inline-block">{{item.label}}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between" :class="{ 'active': isItemActive(item) }" :id="`item-right-${index}`"> 
          <a
            :href="(item.url || {}).url || 'javascript:void(0)'"
            :target="getTarget(item.url)"
            class="h5 text-uppercase py-4 mb-0 px-4"
          >
            {{(item.url || {}).title || item.title}}
          </a>
        </div>
      </div>
    </div>
    <transition enter-active-class="animated slideInLeft faster" leave-active-class="animated slideOutLeft faster">
      <mobile-menu
        v-if="items[subMenuIndex] && items[subMenuIndex].items"
        :items="items[subMenuIndex].items"
        :itemsRight=[]
        :max-depth="maxDepth"
        :back-text="(items[subMenuIndex].url || {}).title || items[subMenuIndex].title"
        :depth="depth + 1"
        :theme="theme"
        @close="subMenuIndex = null"
      ></mobile-menu>
    </transition>
  </div>
</template>

<style lang="scss">
[mobile-menu-component] {

  & {
    position: fixed;
    z-index: $zindex-sticky + 2;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
  }

  .main-box {
    &.light {
      color: $black;
      background-color: $gray-200;

      a { color: $black }

      .arrow-box {
        background-color: #f9f9f9;
        color: $black;
      }
    }
    &.dark {
      color: $white;
      background-color: $dark;

      a { color: $white }

      .arrow-box {
        background-color: $gray-900;
        color: $white;
      }
    }
  }

  .heading {
    height: $header-height-sm;
    &.light {
      color: $black;
      background-color: $gray-300;
    }
    &.dark {
      color: $white;
      background-color: $black;
    }
  }
}
</style>